import { render, staticRenderFns } from "./openPageLogo.vue?vue&type=template&id=b044afaa&scoped=true&"
import script from "./openPageLogo.vue?vue&type=script&lang=js&"
export * from "./openPageLogo.vue?vue&type=script&lang=js&"
import style0 from "./openPageLogo.vue?vue&type=style&index=0&id=b044afaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b044afaa",
  null
  
)

export default component.exports